module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs",
    class: {
      'tabs--center': _vm.tabsAlign === 'center', 'tabs--pills': _vm.mode === 'pills', 'tabs--sm': _vm.size === 'sm', 'tabs--vertical tabs--text-right': _vm.orientation === 'vertical'
    }
  }, [_c('div', {
    staticClass: "tabs-list"
  }, [(_vm.threshold > 0 && _vm.rest$.length > 0) ? _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.$_onCloseDropDown),
      expression: "$_onCloseDropDown"
    }],
    staticClass: "tabs-list__more dropdown",
    class: {
      'dropdown--open': _vm.dropdownActive$
    },
    on: {
      "click": _vm.$_toggleDropDown
    }
  }, [_c('a', {
    staticClass: "dropdown__toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.mode === 'normal' ? _vm.more : ''))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown__menu",
    attrs: {
      "aria-labelledby": "dropdownMenuButton"
    }
  }, _vm._l((_vm.rest$), function(tab, index) {
    return _c('a', {
      key: index,
      staticClass: "dropdown__item",
      attrs: {
        "checked": tab.name === _vm.activeName,
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.$_select(index)
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav",
    class: _vm.listCls
  }, _vm._l((_vm.list$), function(tab, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item",
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      staticClass: "nav-link",
      class: {
        'active': tab.name === _vm.activeName, 'disabled': tab.disabled
      },
      attrs: {
        "href": "javascript:void(0)",
        "title": _vm.title ? tab.label : ''
      },
      on: {
        "click": function($event) {
          return _vm.$_change(index)
        }
      }
    }, [_vm._v(_vm._s(tab.label)), (_vm.closeable$) ? _c('i', {
      staticClass: "aid aid-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$_remove(index)
        }
      }
    }) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e034d2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tabs.vue
// module id = 344
// module chunks = 0